export default __webpack_public_path__ + "static/media/KOD0080-min.937e7192.webp";